function initPhoneInput() {
  const phoneInputs = document.querySelectorAll('.phone-input-js');

  phoneInputs.forEach((input) => {
    input.addEventListener('input', function (e) {
      let value = this.value;
      const cleanedValue = value.replace(/[^0-9+]/g, '');

      if (cleanedValue.includes('+')) {
        const parts = cleanedValue.split('+');
        if (parts.length > 2) {
          const firstPart = parts[0];
          const restParts = parts.slice(1).join('');
          this.value = firstPart + '+' + restParts.replace(/\+/g, '');
        } else {
          this.value = cleanedValue;
        }
      } else {
        this.value = cleanedValue;
      }
    });

    input.addEventListener('keydown', function (e) {
      const key = e.key;
      const allowedKeys = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '+',
        'Backspace',
        'Delete',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ];

      if (e.ctrlKey || e.metaKey) {
        return;
      }

      if (!allowedKeys.includes(key)) {
        e.preventDefault();
      }

      if (key === '+' && this.selectionStart > 0) {
        e.preventDefault();
      }
    });

    input.addEventListener('paste', function (e) {
      e.preventDefault();

      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      const cleanedText = pastedText.replace(/[^0-9+]/g, '');

      const start = this.selectionStart;
      const end = this.selectionEnd;
      const currentValue = this.value;

      const newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);
      this.value = newValue;

      this.selectionStart = this.selectionEnd = start + cleanedText.length;
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initPhoneInput();
});
